import { c as _c } from "react/compiler-runtime";
import { ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import React from 'react';
import Button from '../Button';
import Divider from '../Divider';
import Grid from '../Grid';
import { ArrowLeftIcon } from '../icons/ArrowLeftIcon';
import { ArrowRightIcon } from '../icons/ArrowRightIcon';
import { RightIcon } from '../icons/RightIcon';
import NotificationBadge from '../NotificationBadge';
import Typography from '../Typography';
import Tooltip from '../Tooltip';
import { StyledBreadcrumbs, StyledClientSection, StyledGridNavButtonsContainer, StyledNavActionSection, StyledTopNavigation } from './styles';
import { type ClientSectionProps, type NavActionsSectionProps, type TopNavigationProps } from './types';
const TopNavigation = t0 => {
  const $ = _c(17);
  const {
    clientSection,
    navActionsSection,
    navButtons,
    breadcrumbs
  } = t0;
  let t1;
  if ($[0] !== navButtons) {
    t1 = navButtons != null && <StyledGridNavButtonsContainer><Button variant="text" leftIcon={<ArrowLeftIcon />} onClick={navButtons.handleBackwardClick} disabled={navButtons.isBackwardDisabled} /><Button variant="text" rightIcon={<ArrowRightIcon />} onClick={navButtons.handleForwardClick} disabled={navButtons.isForwardDisabled} /></StyledGridNavButtonsContainer>;
    $[0] = navButtons;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== breadcrumbs) {
    t2 = breadcrumbs != null && <StyledBreadcrumbs separator={<RightIcon />}>{breadcrumbs.pathProps.map((breadcrumbPathProps, index, breadcrumbsPathProps) => breadcrumbsPathProps.length - 1 === index || breadcrumbPathProps.disabled === true ? <Typography key={breadcrumbPathProps.path} variant="h5">{breadcrumbPathProps.label}</Typography> : <breadcrumbs.Link key={breadcrumbPathProps.path} href={breadcrumbPathProps.path}>{breadcrumbPathProps.label}</breadcrumbs.Link>)}</StyledBreadcrumbs>;
    $[2] = breadcrumbs;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Grid item={true} display="flex" alignItems="center" gap="24px" overflow="hidden" flexGrow={1} whiteSpace="nowrap" paddingRight="24px">{t1}{t2}</Grid>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== clientSection) {
    t4 = clientSection.name != null && <><Grid item={true}><ClientSection clientSection={clientSection} /></Grid><Grid item={true} display="flex" alignItems="center" margin="0 29.5px"><Divider vertical={true} height={24} /></Grid></>;
    $[7] = clientSection;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== navActionsSection) {
    t5 = <StyledNavActionSection item={true}><NavActions navActionsSection={navActionsSection} /></StyledNavActionSection>;
    $[9] = navActionsSection;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Grid display="flex" flexDirection="row-reverse" alignItems="center">{t4}{t5}</Grid>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <><StyledTopNavigation container={true}>{t3}{t6}</StyledTopNavigation></>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
const NavActions = t0 => {
  const $ = _c(4);
  const {
    navActionsSection
  } = t0;
  let t1;
  if ($[0] !== navActionsSection) {
    t1 = navActionsSection.map(_temp);
    $[0] = navActionsSection;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const ClientSection = t0 => {
  const $ = _c(13);
  const {
    clientSection: t1
  } = t0;
  const {
    name,
    url,
    IconComponent,
    handleOnClick
  } = t1;
  let t2;
  if ($[0] !== IconComponent) {
    t2 = <ListItemAvatar>{IconComponent}</ListItemAvatar>;
    $[0] = IconComponent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = name ?? "";
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      variant: "h5"
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = url ?? "";
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      variant: "body2"
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t3 || $[5] !== t5) {
    t7 = <ListItemText primary={t3} primaryTypographyProps={t4} secondary={t5} secondaryTypographyProps={t6} />;
    $[4] = t3;
    $[5] = t5;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t2 || $[8] !== t7) {
    t8 = <ListItemButton><ListItem>{t2}{t7}</ListItem></ListItemButton>;
    $[7] = t2;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== handleOnClick || $[11] !== t8) {
    t9 = <StyledClientSection onClick={handleOnClick} role="group" aria-label="client menu">{t8}</StyledClientSection>;
    $[10] = handleOnClick;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default TopNavigation;
export { TopNavigation };
export type { NavButtonsProps } from './types';
function _temp(t0) {
  const {
    IconComponent,
    onClick,
    ariaLabel,
    disabled,
    buttonRef,
    tooltipProps,
    notificationProps
  } = t0;
  let element = <Button aria-label={ariaLabel} ref={buttonRef} variant="tonal" onClick={onClick} leftIcon={IconComponent} disabled={disabled} />;
  if (notificationProps?.value != null) {
    element = <NotificationBadge notificationProps={notificationProps}>{element}</NotificationBadge>;
  }
  if (tooltipProps != null) {
    element = <Tooltip kind="singleline" shouldDelay={disabled !== true} {...tooltipProps}>{disabled === true ? <span>{element}</span> : element}</Tooltip>;
  }
  return <React.Fragment key={ariaLabel}>{element}</React.Fragment>;
}